import { Component, Inject, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';

@Component({
    templateUrl: './auth-layout.component.html',
    styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayotComponent implements OnInit {
    currentLang = '';

    constructor(
        private translate: TranslateService,
        @Inject(DOCUMENT) private document: Document
    ) { }

    ngOnInit(): void {
        this.currentLang = this.translate.currentLang;
        this.document.documentElement.lang = this.translate.currentLang;

        this.translate.onLangChange.subscribe((res: LangChangeEvent) => {
            this.currentLang = res.lang;
            this.document.documentElement.lang = res.lang;
        });
    }

    changeLang(lang: string): void {
        this.translate.use(lang);
    }
}
